class Navigation {
  constructor(nav, toggle) {
    this.active = 'is-open';
    this.nav = nav;

    toggle.addEventListener('click', this.handleNavToggle);
  }

  handleNavToggle = (e) => {
    this.nav.classList.toggle(this.active);
    e.currentTarget.classList.toggle(this.active);
  }
}

const nav = document.querySelector('.js-roboyagi-nav');
const toggle = document.querySelector('.js-roboyagi-nav-toggle');
if (nav !== null && toggle !== null) {
  // eslint-disable-next-line
  new Navigation(nav, toggle);
}
